import HeadingArea from '../../general/HeadingArea'
import axios from 'axios'
import { useState, useEffect } from 'react';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';


const VisitorBook = ({ setLoading }) => {

    const [detail, setDetail] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
const [statusFilter, setStatusFilter] = useState('All');

    const fetchDetail = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.kcian.in/fetch-appointment');

        const appointments = res.data.filter(item => item.status?.toLowerCase() != 'pending');
            setDetail(appointments);           

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchDetail();
    }, [])

    
const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return "--";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


const formatTime = (timeStr) => {
  if (!timeStr) return '--';

  const [hour, minute] = timeStr.split(':');
  let hours = parseInt(hour);
  const minutes = minute;
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
};



const filteredData = detail.filter((r) => {
    const term = searchTerm.toLowerCase();
    const matchesSearch = 
        (r.name?.toLowerCase() || '').includes(term) ||
        (r.phone?.toLowerCase() || '').includes(term) ||
        (r.addedby_name?.toLowerCase() || '').includes(term);

    const matchesStatus =
        statusFilter === 'All' || (r.status?.toLowerCase() === statusFilter.toLowerCase());

    return matchesSearch && matchesStatus;
});


    return (
        <>
    <section className="py-4">
      <div className="px-4">
            <HeadingArea message1="Visits/ Meetings" message2="Visitor Book" />

                <div className='profile-card'>
                    <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                        <span className="profile-heading align-content-center">Visits</span>


<div className='d-flex'>

<div className='pe-2 w-100'>
    <select
        className="profile-input border-bottom rounded-0"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
    >
        <option value="Confirmed">Confirmed</option>
        <option value="Cancelled">Cancelled</option>
        <option value="All">All</option>
    </select>
</div>

    <input
        type='text'
        name='search'
        className='profile-input border-bottom rounded-0'
        placeholder='Search...'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>


                    </div>

                    <div className="table-responsive mt-4">
                        <table className="table w-100 text-center">
                            <thead className="account-thead rounded-4">

                                <th className='rounded-start-4'>S No</th>
                                        <th>Name</th>
                                        <th>Added By</th>
                                        <th>No Of Person</th>
                                        <th>Phone</th>
                                        <th>Date</th>
                                        <th>Attachment</th>
                                                                                <th>Purpose</th>
                                        <th className='rounded-end-4'>Status</th>
                            </thead>

                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((data, id) => (
                                            <tr className='account-tr' key={id}>
                                                <td>{id + 1}</td>
                                                <td>{data.name}</td>
                                                <td>{data.addedby_name} ({data.designation})</td>
                                                <td>{data.no_person}</td>
                                                <td>{data.phone}</td>
                                                <td>{formatDate(data.apt_date)}<br />In Time: {formatTime(data.in_time)}<br />Out Time: {formatTime(data.out_time)}</td>
                                                                                            <td>
                                                {data.file ? (() => {
                                                    // Extract file extension
                                                    const ext = data.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${data.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
<td>{data.purpose}</td>
<td className='fw-semibold' style={{ color: data.status?.toLowerCase() == 'confirmed' ? 'green' : 'red' }}>
  {data.status}
</td>

                                            </tr>
                                        ))
                                ) : (
                                    <tr className='account-tr'>
                                        <td colSpan="8">No appointments found.</td>
                                    </tr>
                                )}
                            </tbody>


                        </table>
                    </div>

                </div>
            </div>
            </section>
        </>
    )
}

export default VisitorBook 